export enum LegacyReferralNotificationMessageStatusEnum {
  Pending = 1,
  Sent = 2,
  Error = 3,
  Cancelled = 4
}

export const LegacyReferralNotificationMessageStatusOptions = [
{ id: 1, label: 'Pending' },
{ id: 2, label: 'Sent' },
{ id: 3, label: 'Error' },
{ id: 4, label: 'Cancelled' }
];
